module.exports = __webpack_public_path__ + "img/image.ec37240d.svg";